import client from '../client';
import * as urls from '../ports/urls';
import actions from '../types';

export const getAuthConfig = () => (): any => {
  return client.get(urls.getAuthConfig(), actions.Auth.GET_AUTH_CONFIG);
};
